import type { VChartSpecPipe } from 'src/types'
import { generateAnnotationPointPipe } from './annotationPointCommon'

export const annotationPoint: VChartSpecPipe = generateAnnotationPointPipe({})
